import classes from "./css/footer.module.css";

const DownTextFooter = (props) => {
  return (
    <div className={classes.footerDownStamp}>
      <div className={classes.signature}>{props.signatureFooter}</div>
      <div className={classes.timeStamp}> &copy; Copyright {props.timestampFooter}</div>
    </div>
  );
};

export default DownTextFooter;
